<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAllSaleIssue')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllSaleIssue()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="
                  user.role.roleName == 'BRANCH_ADMIN' ||
                  user.role.roleName == 'WAREHOUSE_MANAGER' ||
                  user.role.roleName == 'PRODUCTION_MANAGER'
                "
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleIssueList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="grey" @click="showDetail(props.item)">
                  <v-icon>info</v-icon>
                </v-btn>
                <!--<v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="printDetail(props.item, 'printSaleIssueDetail')"
                >
                  <v-icon>print</v-icon>
                </v-btn>-->
                <!-- minus 1 from print count to remove print from sale -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      flat
                      icon
                      :color="
                        props.item.saleOrderPrintCount > 0
                          ? 'success'
                          : 'blue lighten-2'
                      "
                      @click="print(props.item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>print</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ props.item.saleOrderPrintCount }}</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.binName }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!--detail list dialog-->
    <v-dialog
      v-model="showSaleIssueDetailListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <div>
                  <span style="padding-left: 20px; font-weight: bold">
                    Issue Date:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{
                      saleIssue.issueDateInMilliSeconds | formatMsDate
                    }}</span>
                  </v-chip>

                  <span style="padding-left: 20px; font-weight: bold">
                    Issue No:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{
                      saleIssue.issueNo
                    }}</span>
                  </v-chip>

                  <span style="padding-left: 20px; font-weight: bold">
                    Customer:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold"
                      >{{ saleIssue.customerCode }} /
                      {{ saleIssue.customerName }}</span
                    >
                  </v-chip>
                </div>
                <div>
                  <span style="padding-left: 20px; font-weight: bold">
                    Shop Name:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{
                      saleIssue.shopName
                    }}</span>
                  </v-chip>

                  <span style="padding-left: 20px; font-weight: bold">
                    Description:
                  </span>
                  <v-chip>
                    <span style="font-weight: bold">{{
                      saleIssue.description
                    }}</span>
                  </v-chip>
                </div>
              </v-card>
            </v-flex>

            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="detailHeaders"
                  :items="saleIssueDetailList"
                  class="elevation-1"
                  :loading="showDetailListLoading"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.productCode }}</td>
                    <td>{{ props.item.productName }}</td>
                    <td>{{ props.item.factorUnitName }}</td>
                    <td>{{ props.item.qty | decFormat(6) }}</td>
                    <td>{{ props.item.batchNo }}</td>
                    <td>
                      {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
                    </td>
                    <td>
                      {{ props.item.expDateInMilliSeconds | formatMsDate }}
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- print all -->
    <div
      id="printAllSaleIssue"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Issue Date</th>
              <th style="text-align: left">Issue No</th>
              <th style="text-align: left">Customer Name</th>
              <th style="text-align: left">Customer Code</th>
              <th style="text-align: left">Shop</th>
              <th style="text-align: left">Description</th>
              <th style="text-align: left">Updated Date</th>
              <th style="text-align: left">Updated By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allSaleIssueList" :key="index">
              <td style="text-align: left">
                {{ item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td style="text-align: left">{{ item.issueNo }}</td>
              <td style="text-align: left">{{ item.customerName }}</td>
              <td style="text-align: left">{{ item.customerCode }}</td>
              <td style="text-align: left">{{ item.shopName }}</td>
              <td style="text-align: left">{{ item.description }}</td>
              <td style="text-align: left">
                {{ item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td style="text-align: left">{{ item.updatedBy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- print detail -->
    <div
      id="printSaleIssueDetail"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">Sale Issue Note</p>
      </div>

      <div
        style="
          float: left;
          padding-left: 11px;
          padding-top: 11px;
          text-align: left;
          width: 40%;
          font-size: 12px;
        "
      >
        <p style="margin: 2px">Customer Name : {{ saleIssue.customerName }}</p>
        <p style="margin: 2px">Address : {{ saleIssue.address }}</p>
      </div>
      <div
        style="
          float: right;
          padding-right: 11px;
          padding-top: 11px;
          text-align: left;
          width: 50%;
          font-size: 12px;
        "
      >
        <p style="margin: 2px">Issue No : {{ saleIssue.issueNo }}</p>
        <p style="margin: 2px">Description : {{ saleIssue.description }}</p>
      </div>
      <div style="clear: both"></div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead>
            <tr>
              <th style="border: 1px solid black">Product Code</th>
              <th style="border: 1px solid black">Product Name</th>
              <th style="border: 1px solid black">Unit</th>
              <th style="border: 1px solid black">Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allSaleIssueDetailList" :key="index">
              <td style="border: 1px solid black">{{ item.productCode }}</td>
              <td style="border: 1px solid black">{{ item.productName }}</td>
              <td style="border: 1px solid black">{{ item.factorUnitName }}</td>
              <td style="border: 1px solid black">
                {{ item.qty | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { saleIssueService } from "../../services/sale-issue-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "SaleIssueList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showDetailListLoading: false,
    showSaleIssueDetailListDialog: false,
    printAllLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Sale",
        disabled: true,
      },
      {
        text: "Sale Order",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status" },
      { text: "IssueDate", align: "left", value: "issue_date" },
      { text: "Issue No", value: "issue_no" },
      { text: "Invoice No", value: "invoice_no" },
      { text: "Customer Name", value: "c.name" },
      { text: "Customer Code", value: "c.code" },
      { text: "Shop", value: "s.name" },
      { text: "Bin", value: "b.name" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updated_date" },
      { text: "Updated By", value: "updated_by" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updated_date",
      totalItems: 0,
    },
    saleIssueList: [],
    allSaleIssueList: [],
    saleIssueDetailList: [],
    allSaleIssueDetailList: [],
    shopList: [],
    totalRows: 0,
    detailHeaders: [
      { text: "Product Code", align: "left", value: "productCode" },
      { text: "Product Name", value: "productName" },
      { text: "Unit", value: "factorUnitName" },
      { text: "Qty", value: "qty" },
      { text: "Batch No", align: "left", value: "batchNo", sortable: false },
      { text: "MFG Date", align: "left", value: "mfgDate", sortable: false },
      { text: "EXP Date", align: "left", value: "expDate", sortable: false },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      customerCode: "",
      customerName: "",
      shopId: "",
      description: "",
      status: "",
    },
    saleIssue: {},
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleIssueList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "BRANCH_ADMIN" ||
      this.user.role.roleName == "WAREHOUSE_MANAGER"
    ) {
      this.queryParams.shopId = this.user.shopId;
    }

    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    this.getAllShop();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "sale-issue", query: this.queryParams });
      this.getSaleIssueList();
    },
    getSaleIssueList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleIssueService
        .getSaleIssueList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.saleIssueList = res.data.saleIssueList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = { id: "", name: "----All----" };
          this.shopList.unshift(findAll);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    showDetail(saleIssue) {
      this.saleIssue = saleIssue;
      this.getSaleIssueDetailList(saleIssue.id).then(
        (this.showSaleIssueDetailListDialog =
          !this.showSaleIssueDetailListDialog)
      );
    },

    getSaleIssueDetailList(wholeSaleHeaderId) {
      this.showDetailListLoading = true;
      return saleIssueService
        .getSaleIssueDetailList(wholeSaleHeaderId)
        .then((res) => {
          if (res.data) {
            this.saleIssueDetailList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showDetailListLoading = false;
        });
    },

    /*printDetail(saleIssue, divName) {
      this.printAllLoading = true;
      this.saleIssue = saleIssue;
      saleIssueService
        .getSaleIssueDetailList(saleIssue.id)
        .then((res) => {
          if (res.data) {
            this.allSaleIssueDetailList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },*/

    printAll(divName) {
      this.printAllLoading = true;
      saleIssueService
        .getSaleIssueList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allSaleIssueList = res.data.saleIssueList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },

    exportAllSaleIssue() {
      this.printAllLoading = true;
      saleIssueService
        .exportAllSaleIssueExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },

    print(item) {
      this.printAllLoading = true;
      saleIssueService
        .printInvoiceById(item.id)
        .then((res) => {
          var blob = res;
          saleIssueService.showWindowDialog(
            blob,
            "SaleIssueInvoice-" + item.id
          );

          // to update on UI without api call
          item.saleOrderPrintCount += 1;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
  },
};
</script>
